import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InstSuggest from '@/components/SuggestInput/InstSuggest';
import MyCascader from '@/components/MyCascader/MyCascader.vue';
export default {
  components: {
    InstSuggest: InstSuggest,
    MyCascader: MyCascader
  },
  data: function data() {
    return {
      issueTypeData: [],
      instCategoryData: [],
      scopeData: [],
      statusData: [],
      periodData: [],
      catalogueList: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    searchForm: function searchForm() {
      return this.$store.state.search.searchForm;
    },
    myCascaderProps: function myCascaderProps() {
      var cascaderProps = {
        multiple: true,
        checkStrictly: true,
        value: 'typeId',
        label: 'name',
        leaf: 'hasChild',
        emitPath: false
      };
      return _objectSpread({}, cascaderProps);
    }
  },
  created: function created() {
    this.getSearchCondition();
    this.getInstCatalogue();
  },
  methods: {
    getInstCatalogue: function getInstCatalogue() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$API.getRequest({
                  url: '/ie/instCatalogue/tree'
                });
              case 2:
                res = _context.sent;
                _this.catalogueList = res.result || [];
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changePublishDate: function changePublishDate(date) {
      this.$store.dispatch('search/changeFormDate', {
        daterange: date || []
      });
    },
    getSearchCondition: function getSearchCondition() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$API.getRequest({
                  url: 'ie/search'
                });
              case 2:
                res = _context2.sent;
                _this2.issueTypeData = res.result.issueType || [];
                _this2.instCategoryData = res.result.instCategory || [];
                _this2.scopeData = res.result.scope || [];
                _this2.statusData = res.result.status || [];
                _this2.periodData = [{
                  key: 1,
                  value: '1年'
                }, {
                  key: 2,
                  value: '2年'
                }, {
                  key: 3,
                  value: '3年'
                }, {
                  key: 4,
                  value: '4年'
                }, {
                  key: 5,
                  value: '5年'
                }, {
                  key: 0,
                  value: '无有效期'
                }];
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    heightSearch: function heightSearch() {
      this.$store.state.search.searchForm.requestVO.filterField.instTypeName = this.$refs.mycascader.getCheckedNodes().map(function (item) {
        return item.data.fullName;
      }).join(',');
      this.$parent.heightSearch('LC_IE');
      this.showHeightSearch = false;
    },
    reset: function reset() {
      this.$store.dispatch('search/resetSearchForm');
    }
  }
};